<section class="wrapper">
  <div [ngClass]="(currLoanData.inviteType === 'REVIEW_ONLY' && reviewTooltip) ? 'backdrop' : 'disable-tooltip' "></div>
  <div class="container">
    <aside app-nav-aside [class.open]="mobileNavToggle" (navAsideClose)="mobileNavToggle = false"></aside>
    <div class="content-wrapper" [class.sidebar-opened]="mobileNavToggle || mobileInfoToggle">

      <pos-header id="header" [isLogoHeader]="true" [headerClass]="'mobile-header'"
                  (openLeft)="openSideBar($event)"></pos-header>

      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>

    <div [ngClass]="(currLoanData.inviteType === 'REVIEW_ONLY' && reviewTooltip) ? 'broker-tooltip' : 'disable-tooltip' ">
      <div class="tooltip">
        <div class="header">
          <img src="assets/waving-hand.png" alt="">
          <span class="close">
          <svg class="icon sm fill-current" (click)="closeTooltip()">
            <use xlink:href="#cross"></use>
          </svg>
        </span>
        </div>

        <p>Hey <strong>{{loggedInBorr.FirstName}},</strong> I've entered most of the details in your loan application.</p>
        <p>Please verify all the information once and submit it using the button below.</p>
        <a class="action-btn" (click)="closeTooltip()">
          Got It
        </a>

      </div>
    </div>

    <aside app-info-aside [class.open]="mobileInfoToggle"
           (infoAsideClose)="mobileInfoToggle = false"></aside>
  </div>

</section>

<form id="pluid-form" method="GET" style="display: none;"></form>

